export default function Config() {
  const metaElement = document.querySelector(
    'meta[name="w-backend-json"]'
  );
  const json = metaElement ? metaElement.getAttribute('content') : '{}';
  let config = JSON.parse(json);

  return {
    config,
    getVar: function (key, defaultValue = null) {
      if (!key) {
        return config;
      } else {
        return typeof config[key] !== 'undefined'
          ? config[key]
          : defaultValue;
      }
    },
  };
};
